import {
  Flex,
  Heading,
  Link,
  useMediaQuery,
  Box,
  useColorModeValue,
  Skeleton
} from '@chakra-ui/react'
import { Property, PropertyCategory } from 'generated/graphql'
import React from 'react'
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/swiper.min.css'
import 'swiper/components/effect-coverflow/effect-coverflow.min.css'
import 'swiper/components/pagination/pagination.min.css'
import 'swiper/components/navigation/navigation.min.css'

import './styles.scss'

// import Swiper core and required modules
import SwiperCore, { EffectCoverflow, Navigation, Pagination } from 'swiper/core'

import { useAuthContext } from 'context/AuthProvider'
import { useHistory } from 'react-router'
import { PropertyCard } from '..'

// install Swiper modules
SwiperCore.use([EffectCoverflow, Pagination, Navigation])

type Props = {
  properties: Property[] | null
  category: PropertyCategory
  loading: boolean
}
const CategorySection: React.FC<Props> = ({ properties, category, loading }) => {
  const [isTabletOrMobile] = useMediaQuery('(max-width: 40em)')
  const { isAuthenticated } = useAuthContext()
  const history = useHistory()
  const headingColor = useColorModeValue('gray.500', 'gray.300')
  return (
    <Skeleton width="100%" isLoaded={!loading}>
      {properties && properties?.length > 0 && (
        <Box width="100%">
          <Flex width="100%" align="center" justify="space-between">
            <Heading
              textTransform="uppercase"
              color={headingColor}
              fontSize="lg"
              as="h5"
              fontWeight="normal"
            >
              <Link
                onClick={() =>
                  history.push(
                    isAuthenticated
                      ? `/auth/simple-search/${category?.slug}`
                      : `/simple-search/${category?.slug}`
                  )
                }
              >
                {category?.name}
              </Link>
            </Heading>
            <Link
              fontSize="xs"
              textTransform="uppercase"
              onClick={() =>
                history.push(
                  isAuthenticated
                    ? `/auth/simple-search/${category?.slug}`
                    : `/simple-search/${category?.slug}`
                )
              }
            >
              Voir plus
            </Link>
          </Flex>
          <Swiper
            effect={'coverflow'}
            grabCursor={true}
            centeredSlides={true}
            spaceBetween={14}
            slidesPerView={'auto'}
            navigation={!isTabletOrMobile}
            keyboard={{
              enabled: true
            }}
            coverflowEffect={{
              rotate: 50,
              stretch: 0,
              depth: 100,
              modifier: 1,
              slideShadows: true
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true
            }}
            className="propertiesSlider"
          >
            {properties?.map((property) => (
              <SwiperSlide className="categorySlides" key={property?.id}>
                <PropertyCard
                  loading={loading}
                  property={property as Property}
                  onClick={() =>
                    history.push(
                      isAuthenticated
                        ? `/auth/property/${property?.id}`
                        : `/property/${property?.id}`
                    )
                  }
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      )}
    </Skeleton>
  )
}
export default CategorySection
